import InvoicesExpected from '@/views/invoices/Expected.vue'

const router = {
    path: '/invoices/expected',
    name: 'Expected Invoices',
    component: InvoicesExpected,
    meta: {
        title: 'Expected Invoices'
    }
  };

export default router
